import type { OralExamStageGateResponse } from '@/common/api/models/oralExamStageGateResponse';

import { OralExamStageGateCode } from './stageGates';

export type StageGateBlockPresentation = {
  titleKey: string;
  titleDefault: string;
  bodyKey: string;
  bodyDefault: string;
};

export const STAGE_GATE_PRESENTATION: Record<string, StageGateBlockPresentation> = {
  [OralExamStageGateCode.inconsistentInExamPreStart]: {
    titleKey: 'oralExam.stageGate.inconsistentInExamPreStart.title',
    titleDefault: 'Exam did not start cleanly',
    bodyKey: 'oralExam.stageGate.inconsistentInExamPreStart.body',
    bodyDefault:
      'The exam was marked started but your session never began. Ask your supervisor to reset so you can complete setup from the beginning.',
  },
};

/** Returns blocking copy when the polled stage gate refuses entry; null when enterable. */
export function resolveStageGateBlock(
  stageGate?: OralExamStageGateResponse | null,
): StageGateBlockPresentation | null {
  if (!stageGate || stageGate.ok !== false) return null;
  return STAGE_GATE_PRESENTATION[stageGate.code] ?? {
    titleKey: 'oralExam.stageGate.blocked.title',
    titleDefault: 'Cannot continue right now',
    bodyKey: 'oralExam.stageGate.blocked.body',
    bodyDefault: 'This exam step is not available yet. Leave and rejoin, or contact your supervisor.',
  };
}
